
/** Only page navigations: never speculate on API/auth actions or file downloads. */
export function prefetchDestination(href: string, current: string): URL | undefined {
  let url: URL, here: URL;
  try { here = new URL(current); url = new URL(href,here); } catch { return; }
  if (!['http:','https:'].includes(url.protocol) || url.origin !== here.origin) return;
  if (/^\/(?:api|auth|local-api|local-supabase|storage|_next|logout|signout)(?:\/|$)/i.test(url.pathname)) return;
  if (/\.[a-z0-9]{2,8}$/i.test(url.pathname)) return;
  if (url.pathname === here.pathname && url.search === here.search) return;
  url.hash = ''; // Private invitation/share tokens must never enter route prefetch URLs.
  return url;
}


/** Limit route speculation even when the pointer sweeps across a long list. */
export function createRouteIntents(now = Date.now) {
  const recent = new Map<string,number>();
  let burst: number[] = [];
  return {
    claim(href: string) {
      const time = now();
      for (const [key,at] of recent) if (time-at >= 30_000) recent.delete(key);
      burst = burst.filter(at=>time-at < 1000);
      if (recent.has(href) || burst.length >= 4) return false;
      if (recent.size >= 40) recent.delete(recent.keys().next().value!);
      recent.set(href,time); burst.push(time); return true;
    },
    invalidate(href: string) { recent.delete(href); },
  };
}
